import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { BizLowerTierContainer } from './BusinessObjectivesStyledComponents';
import { Section } from '../MerchCardSharedComponents';
import BusinessObjectivesLowerTierMessage from './BusinessObjectivesLowerTierMessage';
import { useSelector } from 'react-redux';
import { businessObjectivesForApiNameSelector } from '../../../selectors/BusinessObjectiveSelectors';
import { LIMIT_INCREASE, REMOVE_BRANDING, UNCATEGORIZED } from 'self-service-api/constants/FeatureCategories';
import BusinessObjectivesFeatures from './BusinessObjectivesFeatures';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { useHistory } from 'react-router-dom';
import { isBusinessObjective } from 'pricing-pages-lib/utils/businessObjectiveUtils';

const BusinessObjectivesContainer = ({
  productLine,
  productLevel,
  commonStyles,
  apiName
}) => {
  const BO = useSelector(state => businessObjectivesForApiNameSelector(state, {
    apiName
  }));
  const features = isBusinessObjective(BO) ? BO.features && BO.features.filter(feature => !feature.hideFromLang) : [];
  const brandingAndLimitFeatures = features.filter(feature => feature.featureCategory === LIMIT_INCREASE || feature.featureCategory === REMOVE_BRANDING);
  const uncategorizedFeatures = features.filter(feature => feature.featureCategory === UNCATEGORIZED);
  const history = useHistory();

  const handleClick = () => {
    getUsageTracker().track('internalLinkClick', {
      name: 'business-objective-link',
      url: '/crm',
      trackingSource: MERCH_CARD
    });
    history.push('/crm');
  };

  if (brandingAndLimitFeatures.length) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Section, {
        "data-selenium-id": "biz-objectives-1",
        className: "p-top-8",
        style: Object.assign({
          msGridRow: 8,
          gridRowStart: 8
        }, commonStyles),
        children: /*#__PURE__*/_jsx(BizLowerTierContainer, {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "merchCards.businessObjectives.freeToolsRemoveBranding",
            options: {
              freeToolsWithIncreasedLimits: /*#__PURE__*/_jsx(UILink, {
                onClick: handleClick,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "merchCards.businessObjectives.freeToolsWithLimits"
                })
              })
            }
          })
        })
      }), /*#__PURE__*/_jsxs(Section, {
        "data-selenium-id": "biz-objectives-2",
        style: Object.assign({
          msGridRow: 9,
          gridRowStart: 9
        }, commonStyles),
        children: [/*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
          productLine: productLine,
          features: brandingAndLimitFeatures
        }), /*#__PURE__*/_jsx(BizLowerTierContainer, {
          className: "p-top-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.businessObjectives.and"
          })
        }), /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
          productLine: productLine,
          features: uncategorizedFeatures
        })]
      })]
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      "data-selenium-id": "biz-objectives-1",
      className: "p-top-8",
      style: Object.assign({
        msGridRow: 8,
        gridRowStart: 8
      }, commonStyles),
      children: /*#__PURE__*/_jsx(BusinessObjectivesLowerTierMessage, {
        productLevel: productLevel,
        productLine: productLine,
        handleClick: handleClick
      })
    }), /*#__PURE__*/_jsx(Section, {
      "data-selenium-id": "biz-objectives-2",
      style: Object.assign({
        msGridRow: 9,
        gridRowStart: 9
      }, commonStyles),
      children: /*#__PURE__*/_jsx(BusinessObjectivesFeatures, {
        productLine: productLine,
        features: uncategorizedFeatures
      })
    })]
  });
};

export default BusinessObjectivesContainer;